// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/DashboardDataDrawer.js
//
// Purpose:
// Reusable Dashboard Drilldown Drawer
//
// Used By:
//
// KPI Cards
// Status Distribution
// SLA Performance
// Ticket Trend
// Engineer Workload
// Engineer Performance
// Feedback Analysis
// Satisfaction Analysis
// Ticket Aging
// ======================================================================

import React from "react";

export default function DashboardDataDrawer({

  open,

  title,

  subtitle,

  rows = [],

  columns = [],

  loading = false,

  onClose,

}) {

  if (!open) {
    return null;
  }

  return (

    <>
      {/* ===================================================== */}
      {/* BACKDROP */}
      {/* ===================================================== */}

      <div
        onClick={onClose}
        style={{
          position: "fixed",

          top: 0,
          left: 0,
          right: 0,
          bottom: 0,

          background:
            "rgba(0,0,0,0.35)",

          zIndex: 2000,
        }}
      />

      {/* ===================================================== */}
      {/* DRAWER */}
      {/* ===================================================== */}

      <div
        style={{
          position: "fixed",

          top: 0,
          right: 0,

          width: "80%",

          maxWidth: 1200,

          height: "100vh",

          background: "#fff",

          zIndex: 2001,

          display: "flex",

          flexDirection: "column",

          boxShadow:
            "-4px 0 18px rgba(0,0,0,0.15)",
        }}
      >

        {/* ================================================= */}
        {/* HEADER */}
        {/* ================================================= */}

        <div
          style={{
            background:
              "linear-gradient(90deg,#0f172a,#1e40af)",

            color: "#fff",

            padding: "18px 22px",

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",
          }}
        >

          <div>

            <div
              style={{
                fontSize: 20,
                fontWeight: 700,
              }}
            >
              {title}
            </div>

            <div
              style={{
                fontSize: 13,
                opacity: 0.9,
              }}
            >
              {subtitle}
            </div>

          </div>

          <button
            onClick={onClose}
            className="btn btn-light btn-sm"
          >
            Close
          </button>

        </div>

        {/* ================================================= */}
        {/* BODY */}
        {/* ================================================= */}

        <div
          style={{
            flex: 1,

            overflow: "auto",

            padding: 20,
          }}
        >

          {/* LOADING */}

          {loading && (

            <div
              className="text-center p-5"
            >
              Loading...
            </div>

          )}

          {/* TABLE */}

          {!loading && (

            <div className="table-responsive">

              <table
                className="table table-striped table-hover align-middle"
              >

                <thead>

                  <tr>

                    {columns.map(
                      (column) => (

                      <th
                        key={column.key}
                      >
                        {column.label}
                      </th>

                    ))}

                  </tr>

                </thead>

                <tbody>

                  {rows.length === 0 && (

                    <tr>

                      <td
                        colSpan={
                          columns.length || 1
                        }
                        className="text-center text-muted"
                      >
                        No records found
                      </td>

                    </tr>

                  )}

                  {rows.map(
                    (row, index) => (

                    <tr key={index}>

                      {columns.map(
                        (column) => (

                        <td
                          key={
                            column.key
                          }
                        >
                          {
                            row[
                              column.key
                            ]
                          }
                        </td>

                      ))}

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>
    </>
  );
}   